module.exports = __webpack_public_path__ + "static/media/Desktop_Purpose_29.2abca831.png";